import { Pipe, PipeTransform } from '@angular/core';
import { CurrentApplicationService } from '../services';

@Pipe({
    name: 'autocomplete',
    standalone: false
})
export class AutocompletePipe implements PipeTransform {
    constructor(
        private readonly _currentApplication: CurrentApplicationService
    ) {}

    transform(formControlName: string): string {
        return (
            'application-' +
            this._currentApplication.currentApplicationId +
            '-' +
            formControlName
        );
    }
}
